<template lang="pug">
IconBtn(@click="download()", title="CSV", icon="mdi-download", v-if="valid")
</template>

<script>
import _ from "underscore";
import CSV from "/libs/utils/CSV";
import { mapGetters } from "vuex";

export default {
  props: ["items"],
  computed: {
    ...mapGetters(["biz"]),
    valid() {
      return this.items && this.items.length;
    },
  },
  methods: {
    download() {
      const csv = new CSV();
      csv.addRow([
        "ID",
        "Time",
        "Server",
        "Item",
        "Value",
        "Reason",
        "Action Time",
      ]);
      if (!this.items || !this.items.length) return;
      const datetime = this.$options.filters.datetime;
      const currency = this.$options.filters.currency;
      _.each(this.items, (o) => {
        csv.addRow([
          o.orderNumber,
          datetime(o.needed),
          o.server,
          o.name,
          currency(o.amount),
          o.reason,
          datetime(o.time),
        ]);
      });
      csv.addRow([this.biz.name]);
      csv.save("void_items");
    },
  },
};
</script>
